import React from 'react';
import { Box, Checkbox, HStack, Icon, Text } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';
import { Tooltip } from './Tooltip';

export interface RememberMeCheckboxProps {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    label: string;
    tooltipText: string;
    name?: string;
}

export const RememberMeCheckbox: React.FC<RememberMeCheckboxProps> = ({
    checked,
    onCheckedChange,
    label,
    tooltipText,
    name = 'rememberMe',
}) => (
    <HStack gap={2} align="center">
        <Checkbox.Root
            checked={checked}
            onCheckedChange={(details) => onCheckedChange(!!details.checked)}
            name={name}
        >
            <Checkbox.HiddenInput />
            <Checkbox.Control
                borderRadius="0"
                borderWidth="2px"
                borderColor="gray.300"
                _checked={{
                    bg: 'yellow.500',
                    borderColor: 'yellow.500',
                }}
            >
                <Checkbox.Indicator color="black" />
            </Checkbox.Control>
            <Checkbox.Label>
                <Text fontSize="md" color="gray.700">
                    {label}
                </Text>
            </Checkbox.Label>
        </Checkbox.Root>
        <Tooltip text={tooltipText}>
            <Box
                cursor="pointer"
                p={1}
                borderRadius="full"
                _hover={{ bg: 'gray.200' }}
                transition="background-color 0.2s"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Icon as={FiInfo} color="gray.600" boxSize={4} />
            </Box>
        </Tooltip>
    </HStack>
);
